import React from "react";
import {
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBContainer,
  MDBIcon,
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBBtn,
  MDBRow,
  MDBCol,
  MDBBtnGroup,
} from "mdb-react-ui-kit";

import "./NavegadorFicheros.css";

import Constantes from "Projects/CC_cubi_clan_project/Utils/Constantes";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { VideoPlayerModal } from "Projects/BOX_BOXconV_project/Components/VideoPlayerModal/VideoPlayerModal";
import { AudioPlayer } from "Projects/BOX_BOXconV_project/Components/AudioPlayer/AudioPlayer";

export class NavegadorFicheros extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      dataModel: [{ label: "Nombre", fieldName: "label" }],
      filaSeleccionada: null,
      pathRoute: [{ label: "Home", path: "/", active: true }],
      showVideoPlayerModal: false,
      mediaUrl: null,
      showAudioPlayer: null,
      audioUrl: null,
    };
  }

  componentDidMount() {
    this.getDirectory();
  }

  handleBreadcrumbClick(element, index) {
    this.getDirectory(element.path);
  }

  handleButtonClick(index, element) {
    console.clear();
    this.setState({ filaSeleccionada: index });
  }

  handleButtonDoubleClick(element) {
    if (element.isDirectory) {
      this.setPathRoute(element);
      this.setState({ filaSeleccionada: null });
      this.getDirectory(element.path);
    } else {
      switch (element.mimeType) {
        case "":
          break;
        default:
          switch (element.fileType) {
            case "IMAGE":
              this.downloadFile(element.path);
              break;
            case "AUDIO":
              this.setState({ showAudioPlayer: true });
              this.setState({ audioUrl: element.path });
              break;
            case "VIDEO":
              this.setState({ showVideoPlayerModal: true });
              this.setState({ mediaUrl: element.path });
              break;
            default:
              this.downloadFile(element.path);
              break;
          }
          break;
      }
    }
  }

  handleCloseModal() {
    this.setState({ showVideoPlayerModal: false });
    this.setState({ mediaUrl: null });
  }

  handleCloseAudioPlayer() {
    this.setState({ showAudioPlayer: false });
    this.setState({ audioUrl: null });
  }

  setPathRoute(element) {
    let pathRoute = [{ label: "Home", path: "/", active: false }];
    let pathList = [];

    let pathArray = element.parent.split("\\");
    for (let path of pathArray) {
      if (path && path !== "") {
        pathList.push(path);
        let pathAux = pathList.join("\\");
        pathRoute.push({ label: path, path: pathAux, active: false });
      }
    }

    if (element.label && element.label !== "") {
      pathRoute.push({
        label: element.label,
        path: element.path,
        active: true,
      });
    } else {
      pathRoute[0].active = true;
    }

    this.setState({ pathRoute: pathRoute });
  }

  getDirectory(inputDir) {
    this.props.onLoading(true);

    let method = "listDirectory";
    method = inputDir ? method + "?Directory=" + inputDir : method;

    doFetch("BOX", method, null)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setPathRoute(data.DATA);
        this.setState({ data: data.DATA.files });
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  }

  downloadFile(inputDir) {
    let url = Constantes.URL_BASE + Constantes.URL_BOX + "download";
    url = inputDir ? url + "?FileName=" + inputDir : url;
    let link = document.createElement("a");
    link.setAttribute("download", "");
    link.href = url;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  getIcon(element) {
    let ico = "";
    if (element.isDirectory) {
      ico = "folder";
    } else {
      switch (element.mimeType) {
        case "application/pdf":
          ico = "file-pdf";
          break;
        default:
          switch (element.fileType) {
            case "IMAGE":
              ico = "file-image";
              break;
            case "AUDIO":
              ico = "file-audio";
              break;
            case "VIDEO":
              ico = "file-video";
              break;
            default:
              ico = "file";
              break;
          }
          break;
      }
    }
    return ico;
  }

  render() {
    return (
      <div>
        <VideoPlayerModal
          showVideoPlayerModal={this.state.showVideoPlayerModal}
          mediaUrl={this.state.mediaUrl}
          closeModal={() => this.handleCloseModal()}
        />
        <MDBContainer fluid>
          <MDBRow className="mb-3">
            <MDBCol size="12">
              <AudioPlayer
                showAudioPlayer={this.state.showAudioPlayer}
                audioUrl={this.state.audioUrl}
                closeAudioPlayer={() => this.handleCloseAudioPlayer()}
              />
            </MDBCol>
          </MDBRow>
          <MDBRow className="mb-3">
            <MDBCol size="12">
              <MDBBreadcrumb className="mb-1 mt-4 ms-3">
                {this.state.pathRoute.map((element, index) => (
                  <MDBBreadcrumbItem key={index} active={element.active}>
                    {element.active ? (
                      element.label
                    ) : (
                      <MDBBtn
                        className="breadcrumbButton"
                        color="tertiary"
                        rippleColor="light"
                        onClick={() =>
                          this.handleBreadcrumbClick(element, index)
                        }
                      >
                        {element.label}
                      </MDBBtn>
                    )}
                  </MDBBreadcrumbItem>
                ))}
              </MDBBreadcrumb>
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol size="12">
              <MDBBtnGroup
                shadow="0"
                aria-label="Basic example"
                className="float-end"
              >
                <MDBBtn color="secondary" outline>
                  <MDBIcon icon="th-list" />
                </MDBBtn>
                <MDBBtn color="secondary" outline>
                  <MDBIcon icon="th" />
                </MDBBtn>
              </MDBBtnGroup>
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol size="12">
              <MDBTable align="middle" responsive hover>
                <MDBTableHead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">Nombre</th>
                  </tr>
                </MDBTableHead>
                <MDBTableBody>
                  {this.state.data.map((element, index) => (
                    <tr
                      key={index}
                      className="table-row"
                      onClick={() => this.handleButtonClick(index, element)}
                      onDoubleClick={() =>
                        this.handleButtonDoubleClick(element)
                      }
                      style={{
                        backgroundColor:
                          this.state.filaSeleccionada === index
                            ? "rgba(0, 102, 192, 0.2)"
                            : "white",
                        cursor: "pointer",
                      }}
                    >
                      <td className="col-ico">
                        <MDBIcon icon={this.getIcon(element)} />
                      </td>
                      <td className="col-lavel">{element.label}</td>
                    </tr>
                  ))}
                </MDBTableBody>
              </MDBTable>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
        <MDBContainer fluid className="my-6"></MDBContainer>
      </div>
    );
  }
}
